export class AnswerTypeUtils {
  private static readonly ANSWERTYPE: {
    [key: number]: { id: number; name: string };
  } = {
    1: { id: 1, name: 'ComboBox' },
    2: { id: 2, name: 'Number' },
    3: { id: 3, name: 'Date' },
    4: { id: 4, name: 'Text' },
    6: { id: 6, name: 'Time' },
  };

  static getAnswerType(id: number): { id: number; name: string } | undefined {
    return this.ANSWERTYPE[id];
  }
}
